export function isFunction(value: unknown): boolean {
    return typeof value === "function";
}

export function isObjectFunction(f: unknown) {
    return f && {}.toString.call(f) === "[object Function]";
}
